import deviceworksLogo from "./deviceworks-logo.png";

// DeviceWorks logo — provided brand mark (circular lifecycle arrows
// + "DeviceWorks" wordmark baked into the image itself).
const DWLogo = ({ size = 28 }) => (
  <img
    src={deviceworksLogo}
    alt="DeviceWorks"
    style={{ height: size, width: "auto", display: "block" }}
  />
);

export default DWLogo;
